export default __webpack_public_path__ + "static/media/upload-arrow.2dd399bd.svg";